import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";
import { ASSIGNMENT_VERSION_LEGACY } from "../../assignments/utils/assignmentUtils.js";

const formatAssignmentPayload = (assignment) => {
  const postMemberFormat = assignment.assignment_members.map((member) => {
    return { ...member, content_id: member.content.content_id };
  });
  delete assignment.assignment_members;
  assignment.assignment_members = postMemberFormat;

  const postClassroomFormat = assignment.assignment_classrooms.map(
    (classroom) => {
      return {
        ...classroom,
        classroom_id: classroom.classroom.id,
        date_assigned: classroom.date_assigned,
      };
    },
  );

  delete assignment.assignment_classrooms;
  assignment.assignment_classrooms = postClassroomFormat;
  assignment.source_content_id = assignment.source_content?.content_id;
  delete assignment.source_content;
  delete assignment.student_assignment_view_records;
  // Remove null objects to prevent API post from failing.
  Object.keys(assignment).forEach((key) => {
    if (assignment[key] === null) delete assignment[key];
  });
  // Once an assignment becomes multi-asset, remove any activities associated with it.
  assignment.activity_members = [];
  return assignment;
};

const useAddToAssignment = () => {
  const createAssignmentPostRequest = useCallback(
    ({
      assignment,
      contentMemberIds,
      districtAdvisoryOverride,
      contentSettingsAdvisoryOverride,
    }) => {
      const assignmentContentIds = assignment?.assignment_members.map(
        (assignmentMember) => assignmentMember.content.content_id,
      );
      contentMemberIds.forEach((contentId, i) => {
        // Only add the content to the assignment if it is not already included
        // in the assignment, and, if the user is licensed to assign the content.
        const okToAddMemberToAssignment =
          !assignmentContentIds.includes(contentId);
        if (okToAddMemberToAssignment) {
          if (districtAdvisoryOverride?.length > 0)
            assignment.district_advisory_override = districtAdvisoryOverride;
          if (contentSettingsAdvisoryOverride?.length > 0)
            assignment.content_settings_override =
              contentSettingsAdvisoryOverride;
          assignment.assignment_members.push({
            content: { content_id: contentId },
            display_order: assignment.assignment_members.length + i,
          });
        }
      });
      assignment.version = ASSIGNMENT_VERSION_LEGACY;
      const assignmentPayload = formatAssignmentPayload(assignment);
      return new Request(
        `${MONOLITH_ORIGIN}/api/v3/assignment/${assignment.content_id}/`,
        {
          method: "POST",
          body: JSON.stringify({ ...assignmentPayload }),
          headers: { "Content-Type": "application/json" },
        },
      );
    },
    [],
  );

  return useRestMutation(createAssignmentPostRequest);
};

export default useAddToAssignment;
